import { render, staticRenderFns } from "./LearningUpload.vue?vue&type=template&id=eda96840"
import script from "./LearningUpload.vue?vue&type=script&lang=js"
export * from "./LearningUpload.vue?vue&type=script&lang=js"
import style0 from "./LearningUpload.vue?vue&type=style&index=0&id=eda96840&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports